import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TCOLanguages } from 'src/app/core/models/i18n.model';
import { I18NService } from 'src/app/core/services/i18n/i18n.service';
import { barService } from 'src/app/core/services/common/bar.service';
import { Group } from 'src/app/core/models/bar.model';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit, OnDestroy {
  public AppName: string = 'GAS BALANCE 360'
  public main: string = 'MAP';

  arr: Group[] = [];
  filteredArr: Group[] = [];

  activeSubItem: any = null;
  selectedItem: any = null;
  isMainPage: boolean = true;
  isNotAuthorize: boolean = true;
  currentRouteSub: string = '';
  public languages: TCOLanguages[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    public translate: TranslateService,
    private router: Router,
    private _i18nService: I18NService,
    private barService: barService
  ) {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateSelectedItem(event.urlAfterRedirects);
        this.currentRouteSub = event.urlAfterRedirects;
      }
    });
  }

  ngOnInit() {
    this.arr = this.barService.getBarData();
    this._i18nService.languages$
      .pipe(takeUntil(this.destroy$))
      .subscribe((languages) => {
        this.languages = languages;
      });
      this.updateSelectedItem(this.router.url);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public selectLang(lang: string) {
    this.translate.use(lang);
  }

  public getSchemaUrl(): string {
    return 'https://indx.tengizchevroil.com/indx/sv/#::TCO/ProcessEng/FD/~Schema';
  }

  updateSelectedItem(currentRoute: string) {
    const routeParts = currentRoute.split('/TCO/ProcessEng/')[1]?.split('/');
    if (!routeParts || routeParts.length < 2) {
      this.filteredArr = [];
      return;
    }

    const [firstPart, secondPart] = routeParts;

    const filterAndMap = (groupId: string, itemId: string) => {
      return this.arr
        .filter(group => group.id === groupId)
        .map(group => ({
          ...group,
          items: group.items
            .filter(item => item.id === itemId)
            .map(item => ({
              ...item,
              childs: item.childs
            }))
        }))
        .filter(group => group.items.length > 0);
    };
    
    /* EXCEPTION CASES
    /* Make Attention:
    /* If routing names is not matching with the sidebar names, we need to handle them manually
    */
    if (
      currentRoute === '/TCO/ProcessEng/FD/KTLSGP/So2Emissions/ProjectedData' ||
      currentRoute === '/TCO/ProcessEng/FD/KTLSGP/So2Emissions/MonthlyReport'
    ){
      this.filteredArr = filterAndMap('FD', 'SO2-EMISSIONS');
    } else if (
      currentRoute === '/TCO/ProcessEng/FGD/IUS/Input/boilers-motohours-data' ||
      currentRoute === '/TCO/ProcessEng/FGD/IUS/Input/heaters-motohours-data' ||
      currentRoute === '/TCO/ProcessEng/FGD/IUS/Input/meters-data'
    ){
      this.filteredArr = filterAndMap('FGD', 'FGD-IUS');
    } else if (
      currentRoute === '/TCO/ProcessEng/FGD/IUS/calculations/boilers-motohours-data' ||
      currentRoute === '/TCO/ProcessEng/FGD/IUS/calculations/heaters-motohours-data' 
    ){
      this.filteredArr = filterAndMap('FGD', 'FGD-IUS');
    } else if ( currentRoute ===  '/TCO/ProcessEng/FGD/IUS/MonthlyReport/monthly-calc'){
      this.filteredArr = filterAndMap('FGD', 'FGD-IUS');
    }  else {
      this.filteredArr = this.arr
      .filter(group => group.routeName === firstPart)
      .map(group => ({
        ...group,
        items: group.items
          .filter(item => item.name === secondPart)
          .map(item => ({
            ...item,
            childs: item.childs
          }))
      }))
      .filter(group => group.items.length > 0);
    }

    this.isMainPage = 
      currentRoute === '/' ||
      currentRoute === '/TCO' ||
      currentRoute === '/TCO/ProcessEng' ||
      currentRoute === '/FD';
    this.isNotAuthorize = 
       currentRoute === '/not-authorized';
    this.selectedItem = null;

    for (let group of this.arr) {
      for (let item of group.items) {
        for (let child of item.childs) {
          if (currentRoute.startsWith(child.route)) {
            this.selectedItem = child;
            return;
          }
          if (child.schilds) {
            for (let schild of child.schilds) {
              if (currentRoute.startsWith(schild.route)) {
                this.selectedItem = child;
                return;
              }
              if (schild.tchilds) {
                for (let tchild of schild.tchilds) {
                  if (currentRoute.startsWith(tchild.route)) {
                    this.selectedItem = child;
                    return;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  isMapActive(): boolean {
    return this.router.isActive('/TCO', true);
  }

  isActive(groupName: string): boolean {
    const currentRoute = this.router.url;
    return currentRoute.includes(`/TCO/ProcessEng/${groupName}/`);
  }

  isSubChildActive(childName: string): boolean {
    const currentRoute = this.router.url;
    return currentRoute.includes(childName);
  }

  isDropdownItemActive(childName: string): boolean {
    const currentRoute = this.router.url;
    return currentRoute.includes(childName);
  }
}